import { render, staticRenderFns } from "./Despacho.vue?vue&type=template&id=00fb4937&"
import script from "./Despacho.vue?vue&type=script&lang=ts&"
export * from "./Despacho.vue?vue&type=script&lang=ts&"
import style0 from "./Despacho.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports